import * as React from 'react';
import {
  TableBody,
} from '@mui/material';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import IconButton from '@mui/material/IconButton';
import { chart_list } from '@55degrees/layout-r18';
import {
  FilterList,
  FilterListContent, FilterListGroupTitle,
  FilterListInfoBox,
  FilterListInfoBoxContent,
  FilterListInfoBoxHeader, FilterListScope,
} from './style';

export default function SelectedFiltersInfoBox({
  filters,
  setResetFiltersScope,
  handleClose,
}) {
  const { itemFilters, workflowStages } = filters;

  function keyMaker(key, name) {
    return `${key}-${name}`;
  }

  const globalItemFilters = itemFilters.global ? Object.entries(itemFilters.global) : [];
  const globalWorkflowStages = workflowStages.global.slice(1).filter((item) => item.isChecked === false);

  const chartsFilters = {};

  for (const key in itemFilters) {
    if (key !== 'global' && workflowStages[key]) {
      chartsFilters[key] = {
        itemFilters: itemFilters[key],
        workflowStages: workflowStages[key],
      };
    }
  }

  const chartsFiltersArray = chartsFilters ? Object.entries(chartsFilters) : {};

  function findNameById(id) {
    const matchingChart = chart_list.find((item) => item.id === id);
    return matchingChart ? matchingChart.name : null;
  }

  globalItemFilters.sort();
  globalWorkflowStages.sort();

  return (
    <TableBody>

      {/* global */}

      {(globalItemFilters.length > 0 || globalWorkflowStages.length > 0)
        ? (
          <FilterListInfoBox>
            <FilterListInfoBoxHeader>
              {'Global Filters (All Charts) '}
              <IconButton
                sx={{ padding: 0, marginRight: '2px' }}
                onClick={() => {
                  setResetFiltersScope('global');
                  handleClose();
                }}
              >
                <RestartAltIcon color="info" fontSize="small" sx={{ zIndex: 1 }} />
              </IconButton>
            </FilterListInfoBoxHeader>

            <FilterListInfoBoxContent>
              {globalItemFilters.length > 0 ? (
                <>
                  <FilterListGroupTitle>Filtered Items:</FilterListGroupTitle>
                  <FilterList>
                    {globalItemFilters.map(([key, item]) => (
                      <li key={keyMaker('li', `${key}-itemFilters-global`)}>
                        <FilterListContent>
                          <FilterListScope>
                            {key}
                            :
                            {' '}
                          </FilterListScope>
                          {(item.map((value) => (value === '' ? 'Empty' : value))).join(', ')}
                        </FilterListContent>
                      </li>
                    ))}
                  </FilterList>
                </>
              ) : null}

              {globalWorkflowStages.length > 0 ? (
                <>
                  <FilterListGroupTitle>Disabled Stages:</FilterListGroupTitle>
                  <FilterList>
                    {globalWorkflowStages.map(({ key, title }) => (
                      <FilterListScope key={keyMaker('span', `${key}-workflowStages-global`)}>
                        <li>
                          {title}
                        </li>
                      </FilterListScope>
                    ))}
                  </FilterList>
                </>
              ) : null}
            </FilterListInfoBoxContent>
          </FilterListInfoBox>
        ) : null}

      {/* charts */}

      {chartsFiltersArray.map(([chartId, values]) => ((
        itemFilters[chartId] || workflowStages[chartId]
          ? Object.keys(itemFilters[chartId]).length > 0
            || Object.values(workflowStages[chartId])
              .filter((item) => item.isChecked === false).length > 0
          : []) ? (
            <FilterListInfoBox>
              <FilterListInfoBoxHeader key={keyMaker('td', `${chartId}-title-chart`)}>
                {findNameById(chartId)}
                <IconButton
                  sx={{ padding: 0, marginRight: '2px' }}
                  onClick={() => {
                    setResetFiltersScope(chartId);
                    handleClose();
                  }}
                >
                  <RestartAltIcon color="info" fontSize="small" sx={{ zIndex: 1 }} />
                </IconButton>
              </FilterListInfoBoxHeader>

              <FilterListInfoBoxContent>
                {Object.keys(itemFilters[chartId]).length > 0 ? (
                  <>
                    <FilterListGroupTitle>Filtered Items:</FilterListGroupTitle>
                    <FilterList>
                      {Object.entries(values).map(([id, object]) => (
                        id === 'itemFilters' ? (
                          Object.entries(object).map(([key, items]) => (
                            <li key={keyMaker('li', `${key}-itemFilters-chart`)}>
                              <FilterListContent>
                                <FilterListScope>
                                  {key}
                                  :
                                  {' '}
                                </FilterListScope>
                                {(items.map((value) => (value === '' ? 'Empty' : value))).join(', ')}
                              </FilterListContent>
                            </li>
                          ))
                        )
                          : null
                      ))}
                    </FilterList>
                  </>
                ) : null}

                {Object.values(workflowStages[chartId])
                  .filter((item) => item.isChecked === false).length >= 1
                  ? (
                    <>
                      <FilterListGroupTitle>Disabled Stages:</FilterListGroupTitle>
                      <FilterList>
                        {Object.entries(values).map(([id, item]) => (
                          id === 'workflowStages' ? (
                            Object.entries(item).map(([key, stage]) => (
                              <FilterListScope key={keyMaker('li', `${key}-workflowStages-chart`)}>
                                {(stage.isChecked === false)
                                  ? (
                                    <li>
                                      {Object.values(stage.id)}
                                    </li>
                                  )
                                  : null}
                              </FilterListScope>
                            ))
                          )
                            : null
                        ))}
                      </FilterList>
                    </>
                  ) : null}
              </FilterListInfoBoxContent>
            </FilterListInfoBox>
        ) : null))}

    </TableBody>
  );
}
